import { render } from "./PermissionBlock.vue?vue&type=template&id=35040b16"
import script from "./PermissionBlock.vue?vue&type=script&lang=js"
export * from "./PermissionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__